import BusBaseInfo from './BusBaseInfo'
import BusRentInfo from './BusRentInfo'
import CountInfo from './CountInfo'
import {saveReservation} from "../../../../../api/book";
import {formatDateTime} from "../../../../../utils/format";

export default {
  name:'CreateBusinessBook',
  components: {
    BusBaseInfo,
    BusRentInfo,
    CountInfo
  },
  props: {
    n: {
      type: Number,
      default: 0
    },
    data: {
      type: Object,
      default: null
    },
    roomsCount: {
      type: Number,
      default: 0
    },
    createContractData: {
      type: Object,
      default: null
    },
    bookstockNumber:{
      type:String,
      default:''
    },
    roomIds:{
      type:String,
      default:''
    },
    projectFid:{
      type:String,
      default:''
    }


  },
  watch: {
    n() {
      this.projectName = ''
      this.$nextTick(() => {
        this.$refs['rentinfo'].init()
        this.$refs['baseinfo'].init()
        this.$refs['countinfo'].init()

      })
      this.show = true
    }
  },
  data() {
    return {
      loading: true,
      show: false,
      projectName: '',
    }
  },
  methods: {
    // setprojectName(value) {
    //   this.projectName = value.projectName
    //   this.projectFid = value.projectFid
    //
    // },
    changeLoading() {
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true
      })
    },
    async ok() {
      let boolRentInfo = await this.$refs['rentinfo'].validate()
      let boolBase = await this.$refs['baseinfo'].validate()
      let accountbool=this.$refs['countinfo'].validate()

      if (!boolRentInfo || !boolBase || !accountbool) {
        this.changeLoading()
        return
      }

      let baseData = this.$refs['baseinfo'].formData
      let rentData = this.$refs['rentinfo'].rentData
      let accountData=this.$refs['countinfo'].countParams
      let params = {
        "contractSignSubjectParamDto": {
          contactsIdcardType:baseData.contactsIdcardType,
          "businessAddress": baseData.businessAddress,
          "businessQualification": baseData.businessQualification,
          "businessQualificationPic": [
            {
              "fid": baseData.businessQualificationPic[0].fid,
              "url": baseData.businessQualificationPic[0].url
            }
          ],
          "businessQualificationType": baseData.businessQualificationType,
          "contactsIdcard": baseData.contactsIdcard,
          "contactsMail": baseData.contactsMail,
          "contactsName": baseData.contactsName,
          "customerUid": baseData.customerUid,
          "proxyPic": [
            {
              "fid": baseData.proxyPic[0].fid,
              "url": baseData.proxyPic[0].url
            }
          ],
          "signName": baseData.signName,
          "subjectType": baseData.subjectType,
          "userPhone": baseData.userPhone
        },
        "customerAccountName": accountData.accountName,
        "customerBankAccount": accountData.bankAccount,
        "customerBankName": accountData.bankName,
        "depositAccount": rentData.depositAccount,
        "houseRentPrice": rentData.houseRentPrice,
        "projectId": this.projectFid,
        // "projectName": "string",
        "rentEndDate": formatDateTime(rentData.conEndDate),
        "rentStartDate":formatDateTime(rentData.conStartDate,false),
        "rentType": rentData.rentType,
        "reservationSignDate": formatDateTime(rentData.reservationSignDate,false),
        "roomNum": this.bookstockNumber,
        "stockFid": this.roomIds,
        "type": 3
      }
      saveReservation(params).then(res => {
        this.$Message.success('预定成功')
        this.show = false
        this.$emit('done')

      }).catch(error => {
        this.$Message.info('预定失败')
        this.show = false
        this.$emit('done')


      })
    },
    cancel() {

    }
  }

}
